import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import _ from "lodash";
import axiosInstance from "../../config/axiosInterceptor";

const styles = {
  page: {
    maxWidth: 1200,
    margin: "32px auto",
    padding: 24,
    background: "#f7fafd",
    borderRadius: 18,
    boxShadow: "0 2px 16px #bbdefb22",
    fontFamily: "inherit"
  },
  heading: {
    fontSize: 32,
    color: "#1565c0",
    fontWeight: 800,
    marginBottom: 16,
    letterSpacing: 0.3,
  },
  filtersRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: 18,
    alignItems: "center",
    marginBottom: 12,
    marginTop: 10,
  },
  select: {
    padding: "8px 10px",
    borderRadius: 8,
    border: "2px solid #bbdefb",
    fontSize: 16,
    minWidth: 120,
    background: "#fff",
    marginLeft: 5,
    outline: "none",
  },
  label: {
    fontWeight: 600,
    color: "#3949ab",
    marginRight: 8
  },
  searchInput: {
    padding: "8px 12px",
    borderRadius: 8,
    border: "2px solid #bbdefb",
    fontSize: 16,
    minWidth: 200,
    outline: "none"
  },
  searchBtn: {
    padding: "7px 15px",
    borderRadius: 8,
    fontWeight: 600,
    fontSize: 16,
    background: "linear-gradient(90deg,#3f51b5 60%,#1976d2 100%)",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    marginLeft: 6
  },
  table: {
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
    background: "#fff",
    borderRadius: 14,
    boxShadow: "0 1px 6px #0d47a11a",
    overflow: "hidden",
    marginTop: 24,
    fontSize: 15
  },
  th: {
    background: "#e3f0fd",
    color: "#333",
    padding: "13px 9px",
    fontWeight: 700,
    fontSize: 15,
    textAlign: "left",
    borderBottom: "1.5px solid #cfd8dc"
  },
  td: {
    padding: "12px 8px",
    fontSize: 15,
    borderBottom: "1px solid #f1f6fa"
  },
  trEven: {
    background: "#f8fbff",
    transition: "background 0.3s"
  },
  trOdd: {
    background: "#fff",
    transition: "background 0.3s"
  },
  labelStatus: {
    display: "inline-block",
    borderRadius: 8,
    fontWeight: 700,
    fontSize: 13,
    padding: "5px 13px"
  },
  statusSettled: {
    background: "#ffecb3",
    color: "#ff9800",
  },
  statusPaid: {
    background: "#e0f7fa",
    color: "#00796b",
  },
  statusUnpaid: {
    background: "#ffe4e6",
    color: "#b71c1c",
  },
  statusVerified: {
    background: "#e0ffd6",
    color: "#338a3e",
  },
  statusPending: {
    background: "#fff9c4",
    color: "#827717"
  },
  statusFailed: {
    background: "#ffe4e6",
    color: "#d32f2f"
  },
  settleBtn: {
    padding: "7px 18px",
    borderRadius: 7,
    border: "none",
    background: "linear-gradient(90deg,#32c766 80%,#27ae60 100%)",
    color: "#fff",
    fontWeight: 600,
    fontSize: 14,
    cursor: "pointer",
    boxShadow: "0 1px 5px #1976d211",
    marginRight: 8,
    transition: "background 0.18s, transform 0.1s",
  },
  invoiceBtn: {
    padding: "7px 13px",
    borderRadius: 7,
    border: "none",
    background: "linear-gradient(90deg,#1976d2 80%,#039be5 100%)",
    color: "#fff",
    fontWeight: 600,
    fontSize: 14,
    cursor: "pointer",
    boxShadow: "0 1px 5px #1976d211",
    marginTop: 4,
    marginLeft: 4,
    textDecoration: "none",
    display: "inline-block",
    transition: "background 0.15s, transform 0.09s"
  },
  pagination: {
    display: "flex",
    alignItems: "center",
    marginTop: 24,
    gap: 18
  },
  paginationBtn: {
    background: "#f1f7fd",
    color: "#1565c0",
    border: "none",
    borderRadius: 6,
    fontWeight: 600,
    fontSize: 15,
    padding: "6px 16px",
    cursor: "pointer",
    margin: "0 3px"
  },
  dateInput: {
    padding: "7px 10px",
    borderRadius: 8,
    border: "2px solid #bbdefb",
    fontSize: 15,
    outline: "none"
  },
  summaryRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: 14,
    marginBottom: 18
  },
  summaryCard: {
    background: "#fff",
    border: "1.5px solid #e3f0fd",
    borderRadius: 12,
    padding: "12px 20px",
    boxShadow: "0 1px 6px #0d47a11a",
    minWidth: 160
  },
  summaryLabel: {
    fontSize: 13,
    fontWeight: 600,
    color: "#78909c",
    textTransform: "uppercase",
    letterSpacing: 0.4
  },
  summaryValue: {
    fontSize: 22,
    fontWeight: 800,
    color: "#1565c0",
    marginTop: 2,
    fontVariantNumeric: "tabular-nums"
  }
};

const Payments = () => {
  const [payments, setPayments] = useState([]);
  const [page, setPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [count, setCount] = useState(0);
  const [totalRs, setTotalRs] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [verificationStatus, setVerificationStatus] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    if (searchQuery !== "") {
      searchPayments(searchQuery);
    } else {
      fetchPayments();
    }
    // eslint-disable-next-line
  }, [entriesPerPage, page, paymentStatus, verificationStatus, startDate, endDate, searchQuery]);

  const renderSerialNumber = (index) => {
    return (page - 1) * entriesPerPage + index + 1;
  };

  const fetchPayments = async () => {
    try {
      setPayments([]);
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_BASEURL5}/admin/withdrawal/plansPayments`,
        {
          params: {
            page,
            limit: entriesPerPage,
            paymentStatus,
            verificationStatus,
            startDate,
            endDate,
          },
        }
      );
      if (response.data) {
        setPayments(response.data.details);
        setCount(response.data.total);
        setTotalRs(response.data.totalRs || 0);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleSearchChange = useCallback(
    _.debounce((value) => {
      setPage(1);
      setSearchQuery(value);
    }, 0),
    []
  );

  const searchPayments = async (query) => {
    try {
      setPayments([]);
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_BASEURL5}/admin/withdrawal/plansPaymentsSearch`,
        {
          params: {
            search: query,
            page,
            limit: entriesPerPage,
            paymentStatus,
            verificationStatus,
            startDate,
            endDate,
          },
        }
      );
      setPayments(response.data.details);
      setCount(response.data.total);
      setTotalRs(response.data.totalRs || 0);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSettlePayment = async (orderId) => {
    const confirmSettle = window.confirm(
      "Are you sure you want to settle this payment?"
    );
    if (confirmSettle) {
      setLoading(true);
      try {
        const response = await axiosInstance.post(
          `${process.env.REACT_APP_BASEURL5}/admin/withdrawal/settlePayment`,
          { orderId }
        );
        if (response.data.success) {
          alert("Payment settled successfully");
          fetchPayments();
        } else {
          alert(`Failed to settle payment: ${response.data.message}`);
        }
      } catch (error) {
        console.error(error.message);
        alert("Error while settling payment.");
      } finally {
        setLoading(false);
      }
    }
  };

  const totalPages = Math.ceil(count / entriesPerPage);

  // Helper for status label
  const statusLabel = (val, map) => {
    let base = { ...styles.labelStatus };
    if (map[val]) Object.assign(base, map[val]);
    return base;
  };

  return (
    <div style={styles.page}>
      <div style={styles.heading}>💸 Payments Management</div>
      <div style={styles.summaryRow}>
        <div style={styles.summaryCard}>
          <div style={styles.summaryLabel}>Total Entries</div>
          <div style={styles.summaryValue}>{count.toLocaleString("en-IN")}</div>
        </div>
        <div style={styles.summaryCard}>
          <div style={styles.summaryLabel}>Total Rs</div>
          <div style={styles.summaryValue}>₹{totalRs.toLocaleString("en-IN")}</div>
        </div>
      </div>
      <div style={styles.filtersRow}>
        <label style={styles.label} htmlFor="entries">Entries:</label>
        <select
          style={styles.select}
          id="entries"
          value={entriesPerPage}
          onChange={(e) => setEntriesPerPage(parseInt(e.target.value))}
        >
          <option value="10">10</option>
          <option value="100">100</option>
          <option value="500">500</option>
          <option value="1000">1000</option>
        </select>

        <label style={styles.label} htmlFor="paymentStatus">Payment Status:</label>
        <select
          style={styles.select}
          id="paymentStatus"
          value={paymentStatus}
          onChange={(e) => setPaymentStatus(e.target.value)}
        >
          <option value="">All</option>
          <option value="1">Paid</option>
          <option value="0">Unpaid</option>
        </select>

        <label style={styles.label} htmlFor="verificationStatus">Verification:</label>
        <select
          style={styles.select}
          id="verificationStatus"
          value={verificationStatus}
          onChange={(e) => setVerificationStatus(e.target.value)}
        >
          <option value="">All</option>
          <option value="1">Verified</option>
          <option value="0">Pending</option>
          <option value="2">Failed</option>
        </select>

        <label style={styles.label} htmlFor="startDate">From:</label>
        <input
          style={styles.dateInput}
          type="date"
          id="startDate"
          value={startDate}
          onChange={(e) => {
            setPage(1);
            setStartDate(e.target.value);
          }}
        />

        <label style={styles.label} htmlFor="endDate">To:</label>
        <input
          style={styles.dateInput}
          type="date"
          id="endDate"
          value={endDate}
          onChange={(e) => {
            setPage(1);
            setEndDate(e.target.value);
          }}
        />

        <label style={styles.label} htmlFor="search">Search:</label>
        <input
          style={styles.searchInput}
          type="text"
          id="search"
          value={searchValue}
          placeholder="Search username/orderId"
          onChange={(e) => setSearchValue(e.target.value)}
        />
        <button
          style={styles.searchBtn}
          onClick={() => handleSearchChange(searchValue)}
          type="button"
        >
          Go
        </button>
      </div>
      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>Sr.</th>
            <th style={styles.th}>Username</th>
            <th style={styles.th}>Number</th>
            <th style={styles.th}>Plan Rs</th>
            <th style={styles.th}>Coins</th>
            <th style={styles.th}>RazorPay<br />Amount (Paisa)</th>
            <th style={styles.th}>Order ID</th>
            <th style={styles.th}>Payment Status</th>
            <th style={styles.th}>Verification</th>
            <th style={styles.th}>Invoice</th>
            <th style={styles.th}>Created At</th>
            <th style={styles.th}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {payments.length === 0 ? (
            <tr>
              <td colSpan={12} style={{
                ...styles.td,
                color: "#1565c0",
                textAlign: "center"
              }}>
                Loading...
              </td>
            </tr>
          ) : (
            payments.map((payment, i) => (
              <tr
                key={payment._id}
                style={i % 2 === 0 ? styles.trEven : styles.trOdd}
                onMouseEnter={e => e.currentTarget.style.background = "#e3f2fd"}
                onMouseLeave={e => e.currentTarget.style.background = (i % 2 === 0 ? "#f8fbff" : "#fff")}
              >
                <td style={styles.td}>{renderSerialNumber(i)}</td>
                <td style={styles.td}>{payment.user?.username}</td>
                <td style={styles.td}>{payment.user?.number}</td>
                <td style={styles.td}>{payment.plan?.rs}</td>
                <td style={styles.td}>{payment.plan?.coins}</td>
                <td style={styles.td}>{payment.amount}</td>
                <td style={styles.td}>{payment.orderId}</td>
                <td style={styles.td}>
                  {payment.settled == 1 ? (
                    <span style={statusLabel(1, { 1: styles.statusSettled })}>Settled</span>
                  ) : (
                    <span style={statusLabel(payment.paymentStatus, {
                      0: styles.statusUnpaid,
                      1: styles.statusPaid
                    })}>
                      {payment.paymentStatus == 0 ? "Unpaid" : "Paid"}
                    </span>
                  )}
                </td>
                <td style={styles.td}>
                  <span style={statusLabel(payment.verificationStatus, {
                    0: styles.statusPending,
                    1: styles.statusVerified,
                    2: styles.statusFailed
                  })}>
                    {payment.verificationStatus == 0
                      ? "Pending"
                      : payment.verificationStatus == 1
                      ? "Verified"
                      : "Failed"}
                  </span>
                </td>
                <td style={styles.td}>
                  {payment.invoicePath ? (
                    <a
                      href={payment.invoicePath}
                      style={styles.invoiceBtn}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View Invoice
                    </a>
                  ) : (
                    <span style={{ color: "#aaa" }}>N/A</span>
                  )}
                </td>
                <td style={styles.td}>
                  {new Date(payment.createdAt).toLocaleString()}
                </td>
                <td style={styles.td}>
                  <button
                    style={{
                      ...styles.settleBtn,
                      opacity: loading || payment.settled == 1 ? 0.65 : 1,
                      background:
                        payment.settled == 1
                          ? "linear-gradient(90deg,#fbc02d 80%,#ffa726 100%)"
                          : styles.settleBtn.background,
                      cursor:
                        loading || payment.settled == 1
                          ? "not-allowed"
                          : "pointer"
                    }}
                    onClick={() => handleSettlePayment(payment.orderId)}
                    disabled={loading || payment.settled == 1}
                  >
                    {payment.settled == 1
                      ? "Settled"
                      : "Settle Payment"}
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      {/* Pagination */}
      <div style={styles.pagination}>
        <span>Total Entries: <b>{count}</b></span>
        <button
          style={styles.paginationBtn}
          onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
          disabled={page === 1}
        >
          Previous
        </button>
        <span style={{ fontWeight: 600 }}>Page {page} / {totalPages || 1}</span>
        <button
          style={styles.paginationBtn}
          onClick={() => setPage((prev) => (page < totalPages ? prev + 1 : prev))}
          disabled={page === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Payments;
